import { defineMessages } from "react-intl";

export const messages = defineMessages({
    runbooksPanelTitle: {
        id: "fastshift.migration-tickets-page.runbooks-panel.title",
        defaultMessage: "Runbooks",
        description: "Title for the runbooks side panel"
    },
    runbooksPanelCloseButtonAriaLabel: {
        id: "fastshift.migration-tickets-page.runbooks-panel.close-button-aria-label",
        defaultMessage: "Close runbooks",
        description: "Aria label for the close button in the runbooks panel"
    },
    runbooksPanelLoadingRunbooks: {
        id: "fastshift.migration-tickets-page.runbooks-panel.loading-runbooks",
        defaultMessage: "Loading runbooks…",
        description: "Loading message while runbook summaries are fetched"
    },
    runbooksPanelLoadingRunbookDetails: {
        id: "fastshift.migration-tickets-page.runbooks-panel.loading-runbook-details",
        defaultMessage: "Loading runbook details…",
        description: "Loading message while runbook details are fetched"
    },
    runbooksPanelErrorMessage: {
        id: "fastshift.migration-tickets-page.runbooks-panel.error-message",
        defaultMessage: "We couldn’t load runbooks for this ticket.",
        description: "Error message when runbook summaries fail to load"
    },
    runbooksPanelDetailErrorMessage: {
        id: "fastshift.migration-tickets-page.runbooks-panel.detail-error-message",
        defaultMessage: "We couldn’t load this runbook.",
        description: "Error message when runbook details fail to load"
    },
    runbooksPanelRetryButton: {
        id: "fastshift.migration-tickets-page.runbooks-panel.retry-button",
        defaultMessage: "Retry",
        description: "Button label to retry loading runbooks or runbook details"
    },
    runbooksPanelEmptyMessage: {
        id: "fastshift.migration-tickets-page.runbooks-panel.empty-message",
        defaultMessage: "No runbooks are available for this ticket.",
        description: "Empty state message when a ticket has no runbooks"
    },
    runbooksPanelExpandRunbookLabel: {
        id: "fastshift.migration-tickets-page.runbooks-panel.expand-runbook-label",
        defaultMessage: "Expand {title}",
        description: "Accessible label for expanding a runbook card"
    },
    runbooksPanelCollapseRunbookLabel: {
        id: "fastshift.migration-tickets-page.runbooks-panel.collapse-runbook-label",
        defaultMessage: "Collapse {title}",
        description: "Accessible label for collapsing a runbook card"
    },
    runbooksPanelCreatedAtLabel: {
        id: "fastshift.migration-tickets-page.runbooks-panel.created-at-label",
        defaultMessage: "Created",
        description: "Label for the runbook created date metadata"
    },
    runbooksPanelModifiedAtLabel: {
        id: "fastshift.migration-tickets-page.runbooks-panel.modified-at-label",
        defaultMessage: "Modified",
        description: "Label for the runbook modified date metadata"
    },
    runbooksPanelNextReviewLabel: {
        id: "fastshift.migration-tickets-page.runbooks-panel.next-review-label",
        defaultMessage: "Next review",
        description: "Label for the runbook next review date metadata"
    },
    runbooksPanelStepsTitle: {
        id: "fastshift.migration-tickets-page.runbooks-panel.steps-title",
        defaultMessage: "Steps",
        description: "Title for the steps list inside an expanded runbook"
    },
    runbooksPanelOpenRunbookLabel: {
        id: "fastshift.migration-tickets-page.runbooks-panel.open-runbook-label",
        defaultMessage: "Open {title} in Marathon",
        description:
            "Accessible label for the link button that opens a runbook in Marathon"
    },
    runbooksPanelProductLabel: {
        id: "fastshift.migration-tickets-page.runbooks-panel.product-label",
        defaultMessage: "Product",
        description: "Label for the runbook product metadata"
    },
    runbooksPanelJiraProductName: {
        id: "fastshift.migration-tickets-page.runbooks-panel.jira-product-name",
        defaultMessage: "Jira",
        description: "Runbook product name for Jira"
    },
    runbooksPanelConfluenceProductName: {
        id: "fastshift.migration-tickets-page.runbooks-panel.confluence-product-name",
        defaultMessage: "Confluence",
        description: "Runbook product name for Confluence"
    },
    runbooksPanelResponsibleLabel: {
        id: "fastshift.migration-tickets-page.runbooks-panel.responsible-label",
        defaultMessage: "Responsible",
        description: "Label for the runbook step responsible metadata"
    },
    runbooksPanelStepDoneIconLabel: {
        id: "fastshift.migration-tickets-page.runbooks-panel.step-done-icon-label",
        defaultMessage: "Done",
        description: "Accessible label for a completed runbook step icon"
    },
    runbooksPanelStepRiskIconLabel: {
        id: "fastshift.migration-tickets-page.runbooks-panel.step-risk-icon-label",
        defaultMessage: "At risk",
        description: "Accessible label for a runbook step risk icon"
    },
    runbooksPanelStepDisabledIconLabel: {
        id: "fastshift.migration-tickets-page.runbooks-panel.step-disabled-icon-label",
        defaultMessage: "Disabled",
        description: "Accessible label for a disabled runbook step icon"
    },
    runbooksPanelOtherPhaseLabel: {
        id: "fastshift.migration-tickets-page.runbooks-panel.other-phase-label",
        defaultMessage: "Other",
        description:
            "Fallback phase group label for runbook steps without a phase"
    }
});
